import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import { Loadable } from '../base/components/Lodable'

const ModificadoresGestionApp = Loadable(lazy(() => import('./view/ModificadoresGestion')))
const ModificadoresRegistro = Loadable(lazy(() => import('./view/upsert/registro/ModificadoresRegistro')))
const ModificadoresActualizar = Loadable(
  lazy(() => import('./view/upsert/actualizacion/ModificadoresActualizar')),
)
export const modificadoresRoutesMap = {
  gestion: {
    path: '/modificadores/gestion',
    name: 'Modificadores',
    action: 'MODIFICADORES',
  },
  registro: {
    path: '/modificadores/registro',
    name: 'Registro de Modificadores',
    action: 'MODIFICADORES_REGISTRO',
  },
  actualizar: {
    path: '/modificadores/actualizar',
    name: 'Actualizar Modificador',
    action: 'MODIFICADORES_ACTUALIZAR',
  },
}

const modificadoresRoutes = [
  {
    path: modificadoresRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <ModificadoresGestionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: modificadoresRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <ModificadoresRegistro />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: `${modificadoresRoutesMap.actualizar.path}/:id`,
    element: (
      <OperacionesProvider>
        <ModificadoresActualizar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default modificadoresRoutes
